/* Developed by MontenegroSoft - www.montenegrosoft.com */

let ytPlayers=[];

function pauseOthers(current){
  ytPlayers.forEach(p=>{
    if(p!==current){
      p.pauseVideo();
    }
  });
}

function onYouTubeIframeAPIReady(){
  document.querySelectorAll('iframe.js-youtube').forEach(el=>{
    const player=new YT.Player(el,{
      events:{
        onReady:e=>{
          ytPlayers.push(e.target);
        },
        onStateChange:e=>{
          if(e.data===YT.PlayerState.PLAYING){
            pauseOthers(e.target);

            if(e.target.isMuted()){
              e.target.unMute();
            }
          }
        }
      }
    });
  });
}

(function(){
  const tag=document.createElement('script');
  tag.src="https://www.youtube.com/iframe_api";
  document.head.appendChild(tag);
})();